import Vue from "vue";
import VueRouter from "vue-router";
import LoginFam from "@/views/LoginFam";
import Login from "@/views/Login";
import Intro from "@/views/Intro";
import store from "@/store";
import Start from "@/views/Start";
Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: [
    {
      path: "/intro",
      name: "Intro",
      component: Intro,
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
    },
    {
      path: "/loginB",
      name: "LoginB",
      component: () =>
        import(/* webpackChunkName: "loginB" */ "@/views/LoginB"),
    },
    {
      path: "/",
      name: "LoginFam",
      component: LoginFam,
    },
    {
      path: "/modules",
      name: "Modules",
      component: () =>
        import(/* webpackChunkName: "modules" */ "@/views/Modules"),
      beforeEnter(to, from, next) {
        if (store.state.auth.token) {
          next();
        } else {
          next("/loginfam");
        }
      },
    },
    {
      path: "/familie",
      name: "Module1",
      component: () =>
        import(/* webpackChunkName: "moduleA" */ "@/views/Module1"),
    },
    {
      path: "/toekomstvisie",
      name: "Module2",
      component: () =>
        import(/* webpackChunkName: "moduleB" */ "@/views/Module2"),
    },
    {
      path: "/eigendom_en_financien",
      name: "Module3",
      component: () =>
        import(/* webpackChunkName: "moduleC" */ "@/views/Module3"),
    },
    {
      path: "/opvolging",
      name: "Module4",
      component: () =>
        import(/* webpackChunkName: "moduleD" */ "@/views/Module4"),
    },
    {
      path: "/beloning",
      name: "Module5",
      component: () =>
        import(/* webpackChunkName: "moduleE" */ "@/views/Module5"),
    },
    {
      path: "/socialmedia",
      name: "Module15",
      component: () =>
        import(/* webpackChunkName: "moduleA" */ "@/views/Module6"),
    },
    {
      path: "*",
      component: Start,
      name: "Start",
    },
  ],
});

export default router;
